// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-detail-container[data-v-69aa2301]{margin-bottom:10rem}.product-detail-page-nav[data-v-69aa2301]{align-items:center;display:flex;justify-content:space-between}.product-detail-page-nav .btn[data-v-69aa2301]{margin:0 2rem}@media screen and (min-width:992px){.product-cart-wrap[data-v-69aa2301]{position:sticky;top:130px}}@media screen and (max-width:992px){.product-detail-page-nav .btn[data-v-69aa2301]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
